<template>
  <div>
    <component
      :is="label.startsWith('L') ? phaseIdxToColor(phase) : coloredInput[color]"
      :id="resolvedInputId"
      :value="value"
      size="large"
      class="input-box"
      placeholder="Type in unit name"
      :disabled="disabled || !checked"
      :data-tn="`unit-input-${label}`"
      @input="onInput"
    >
      <template #addonBefore>
        <span class="label"> {{ label }} </span>
      </template>
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope" />
      </template>
      <template v-if="disabled" #suffix>
        <a-checkbox class="checkbox" :checked="checked" />
      </template>
    </component>
    <IdealPostcodesAutoComplete
      v-if="useIdealPostcodes"
      :value="value"
      :checked="checked"
      :disabled="disabled"
      :input-id="resolvedInputId"
      @input="onIdealInput"
      @entry-meta-change="onEntryMetaChange"
    />
  </div>
</template>

<script>
import {
  BlueInput,
  GreenInput1,
  GreenInput2,
  RedInput,
  WhiteInput,
} from "./StyledInput";
import IdealPostcodesAutoComplete from "./IdealPostcodesAutoComplete";
import { COLORS, COUNTRY_CODE } from "../util/constants";

export default {
  name: "UnitInputAddressNameBox",
  components: { IdealPostcodesAutoComplete },
  props: {
    label: { type: String, default: "1" },
    value: { type: String, default: "" },
    color: { type: String, default: COLORS.WHITE },
    phase: { type: Number, default: 1 },
    checked: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    inputId: { type: String, default: "" },
    country: { type: String, default: null },
  },
  data() {
    return {
      coloredInput: {
        [COLORS.WHITE]: WhiteInput,
        [COLORS.RED]: RedInput,
        [COLORS.BLUE]: BlueInput,
        [COLORS.GREEN1]: GreenInput1,
        [COLORS.GREEN2]: GreenInput2,
      },
    };
  },
  computed: {
    resolvedCountry() {
      if (this.country) {
        return this.country;
      }
      return this.$store?.state?.project?.address?.country || null;
    },
    useIdealPostcodes() {
      return this.resolvedCountry === COUNTRY_CODE["United Kingdom"];
    },
    resolvedInputId() {
      return this.inputId || `lookup-address-${this.phase}-${this._uid}`;
    },
  },
  methods: {
    phaseIdxToColor(phase) {
      switch (phase) {
        case 1:
          return WhiteInput;
        case 2:
          return GreenInput1;
        case 3:
          return GreenInput2;
        default:
          return WhiteInput;
      }
    },
    onInput(value) {
      this.$emit("input", value);
      if (!this.useIdealPostcodes) {
        this.$emit("entry-meta-change", {
          externalPropertyId: null,
          externalPropertyIdSource: null,
        });
      }
    },
    onIdealInput(value) {
      this.$emit("input", value);
    },
    onEntryMetaChange(meta) {
      this.$emit("entry-meta-change", meta);
    },
  },
};
</script>

<style lang="less" scoped>
.label {
  font-size: 19px;
  font-family: "Helvetica Light", sans-serif;
}
.checkbox {
  margin-right: 14px;
}
</style>
